import { connect } from 'react-redux'
import { Flex } from 'rebass'
import { get } from 'lodash/fp'

import Button from 'e-submission/components/Button'
import { getIcon } from 'e-submission/components/Icon'
import { getEdaStatus, createNewEda, removeEDACheckStatus, changeEdaBankAccount } from 'e-submission/apps/actions'
import {
  isEDACheckingStatus,
  isEDACheckingStatusError,
  isEDACheckingStatusExpired,
  getCurrentApp,
} from 'e-submission/apps/selectors'
import {
  getATPBank,
  getATPBankText,
  getPolicyId,
  getRecurringPayment,
} from 'e-submission/domain/data-model/form/selectors'

function expirationTime(bankValue) {
  switch (bankValue) {
    case '006':
      return '5'
    case '025':
      return '15'
  }
  return '5'
}

const EDACheckStatusPage = (props) => {
  const {
    onClickCheckStatus,
    onClickResendForm,
    isLoading,
    isStatusError,
    isStatusExpired,
    policyId,
    accountNo,
    changeBankAccount,
    atpBankText,
    bankValue,
    unsetCheckStatusEDA,
    EtoggleModal,
  } = props

  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <div className="spinner-eda"></div>
        </div>
      )}
      <div className="eda-check-status">
        <label className="heading">สมัครหักค่าเบี้ยประกันอัตโนมัติผ่านบัญชีธนาคาร</label>
        <div className="content-container">
          <div className="sub-heading">ตรวจสอบสถานะผลการสมัครหักค่าเบี้ยประกันอัตโนมัติผ่านบัญชีธนาคาร</div>
          <div className="sub-heading sub-heading-bank-text">{atpBankText}</div>
          <div className="info-message">
            <div className="icon">{getIcon('checkFillCircle')}</div>
            กรุณาตรวจสอบแอปพลิเคชั่นธนาคารที่ต้องการตัดบัญชีธนาคารอัตโนมัติ
          </div>
          <Flex column width={1} align="center" className="button-container">
            {!isStatusExpired && (
              <Button className="btn-col" onClick={() => onClickCheckStatus(EtoggleModal)}>
                ตรวจสอบสถานะ
              </Button>
            )}
            {(isStatusExpired || isStatusError) && (
              <Button
                className="btn-col"
                outline={!isStatusExpired}
                onClick={() => onClickResendForm(policyId, accountNo)}
              >
                สมัครอีกครั้ง
              </Button>
            )}
            {(isStatusExpired || isStatusError) && (
              <Button className="btn-col" outline onClick={changeBankAccount}>
                เปลี่ยนบัญชีธนาคาร
              </Button>
            )}
            {(isStatusExpired || isStatusError) && (
              <Button className="btn-col" outline onClick={unsetCheckStatusEDA}>
                เปลี่ยนวิธีการสมัคร
              </Button>
            )}
          </Flex>
          <div className="info-message attached-icon form-control-feedback">
            <p>กรุณาทำรายการสมัครผ่านแอพพลิเคชันของทางธนาคารให้แล้วเสร็จภายใน {expirationTime(bankValue)} นาที</p>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  const isLoading = isEDACheckingStatus(state)
  const isStatusError = isEDACheckingStatusError(state)
  const isStatusExpired = isEDACheckingStatusExpired(state)

  const app = getCurrentApp(state)
  const recurringPayment = getRecurringPayment(app)
  const policyId = getPolicyId(app)
  const atpBankText = getATPBankText(app)
  const accountNo = get('bankBookNumber', recurringPayment)
  const bankValue = getATPBank(app)

  return {
    isLoading,
    isStatusError,
    isStatusExpired,
    policyId,
    accountNo,
    atpBankText,
    bankValue,
  }
}
const mapDispatchToProps = (dispatch) => ({
  onClickCheckStatus: (toggleModal) => {
    dispatch(getEdaStatus(toggleModal))
  },
  onClickResendForm: (policyId, accountNo) => {
    const payload = {
      accountNo: accountNo,
      policyNo: policyId,
      bankName: 'KTB', // only KTB for now
      applyDtm: new Date().getTime(),
    }
    dispatch(createNewEda(payload))
  },
  unsetCheckStatusEDA: () => {
    dispatch(removeEDACheckStatus())
  },
  changeBankAccount: () => {
    dispatch(changeEdaBankAccount())
  },
})

export default (hoc) => hoc(connect(mapStateToProps, mapDispatchToProps)(EDACheckStatusPage))
